export function Footer() {
  return (
    <footer className="bg-background border-t border-border py-4 px-6">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          © {new Date().getFullYear()} Source Code Control. All Rights Reserved.
          <div className="flex space-x-4 pt-1">
            <a
              href="/terms-of-service"
              className="block text-xs text-sidebar-foreground/70 hover:text-sidebar-foreground hover:underline transition-colors duration-200"
            >
              Terms and Conditions
            </a>
          | &nbsp; &nbsp;
            <a
              href="/privacy-policy"
              className="block text-xs text-sidebar-foreground/70 hover:text-sidebar-foreground hover:underline transition-colors duration-200"
            >
              Privacy Policy
            </a>
        | &nbsp; &nbsp;
            <a
              href="/gdpr-policy"
              className="block text-xs text-sidebar-foreground/70 hover:text-sidebar-foreground hover:underline transition-colors duration-200"
            >
              GDPR Policy
            </a>
          </div>
        </p>
        <p className="text-sm text-muted-foreground">
          <a href="https://github.com/oss-review-toolkit/ort" target="_blank" rel="noopener noreferrer">Built using OSS Review Toolkit</a>
        </p>
      </div>
    </footer>
  );
}